import React from "react";
import { Paper } from "@mui/material";
import DoctorsForm from "../components/DoctorsForm";
import DoctorsTable from "../components/DoctorsTable";
const DoctorsContainer = () => {
  return (
    <React.Fragment>
      <Paper sx={{ maxWidth: "1200px !important", p: 2 }}>
        <DoctorsForm />
        <DoctorsTable />
      </Paper>
    </React.Fragment>
  );
};

export default DoctorsContainer;
